<template>
    <div class="container">
        <div class="row justify-content-center margin-top">
            <div class="col-lg-12 col-12">
                <div class="login"><h2>{{ welcome }}</h2></div>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-lg-6 col-10">
                <div class="row">
                    <input type="text" class="form-control marge" v-model="in_username" :placeholder="username" />
                </div>
                <div class="row">
                    <input type="password" class="form-control marge" @keyup.enter="tryLogIn" v-model="in_password" :placeholder="password" />
                </div>
                <div class="row">
                    <button type="button" @click.prevent="tryLogIn" class="btn btn-primary marge">
                        <span v-if="isLoading" class="spinner-border spinner-border-sm"></span>
                        {{ login }}</button>
                </div>
                <div v-if="logInError" class="row alert alert-danger justify-content-center">
                    {{ logInError }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default{
    name:'LoginPage',
    data() {
        return {
            in_password: '',
            isLoading: false,
        }
    },
    computed:{
        in_username:{
            get(){
                return this.$store.state.userCookies.username;
            },
            set(username){
                this.$store.commit('setUsername', username);
            }
        },
        welcome(){
            return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.welcome : 'Welcome to the Pilous Company\'s Pooling Portal!';
        },
        username(){
            return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.username : 'Username';
        },
        password(){
            return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.password : 'Password';
        },
        login(){
            return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.login_button : 'Log in';
        },
        logInError(){
            return this.$store.state.sessionData.logInError;
        },
        serverside_error(){
            return this.$store.state.languageData.languageArray.serverside_error;
        }
    },
    methods: {
        async tryLogIn(){
            this.isLoading = true;
            await axios.post(`${this.$store.state.serverData.backend}/api/login`,{username:this.in_username,password:this.in_password})
            .catch(() => {
                this.$store.dispatch('setLogInError','serverside_error');
            }).then((response) => {
                const responseData = response.data;
                if(Object.hasOwn(responseData,'original')){
                    this.$store.dispatch('setLogInError',responseData.original.error);
                }
                if(Object.hasOwn(responseData,'username') && Object.hasOwn(responseData,'token')){
                    this.$store.dispatch('logIn',responseData);
                }
            });
            this.isLoading = false;
        }
    },
}
</script>

<style scoped>
.login{
    text-align: center;
}
.marge{
    margin-top: 10px;
    margin-bottom: 10px;
}
</style>